import { render, staticRenderFns } from "./bigWeb.vue?vue&type=template&id=a6c9ff3c&scoped=true&"
import script from "./bigWeb.vue?vue&type=script&lang=js&"
export * from "./bigWeb.vue?vue&type=script&lang=js&"
import style0 from "./bigWeb.vue?vue&type=style&index=0&id=a6c9ff3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c9ff3c",
  null
  
)

export default component.exports